export const SUBGROUP_COLUMN = {
  STRATA: 'Stratify By',
  SLIDER: 'Slider',
  PAGE_FILTER: 'Page Filter',
  PRIMARY: 'Display Filter',
  FILTERS: 'Other Filters',
  SPLIT_FILTER: 'Split Filter'
}
